<template>
  <v-input-number
    v-model="valueBackUp"
    :precision="2"
    :placeholder="placeholderBackup"
    type="unsignedTinyInt"
    :is-show-suffix="true"
    suffix-name="%"
    :disabled="disabled"
    :min="0"
    :max="100"
    @change="currentValue => $emit('change', currentValue)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valueBackUp: '',
    placeholderBackup: '请输入百分比',
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value;
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
  },
  beforeMount() {
    this.valueBackUp = +this.value || '';
    if (this.placeholder) this.placeholderBackup = this.placeholder;
  },
};
</script>
